import { Component } from 'vue-property-decorator';
import './single-sorting.component.scss';
import SortingModal from '@/tsort/views/sorting/modal/common-sorting/sorting-modal.component';
import { SortModalType } from '@/tsort/enum/sort-modal-type.enum';
import { CancelTaskRequest } from '@/tsort/model/request/cancel-task-request.model';
import { GoFlagOnWarnType } from '@/tsort/enum/go-flag-on-warn-type.enum';
import FlashMessage from '@/common/components/flash-message.component';
import SwipeButton from '@/common/components/swipe-button/swipe-button';
import FooterComponent from '@/tsort/views/sorting/footer/footer.component';
import AppConstants from '@/common/constants/app.constants';
import LoadingComponent from '@/common/components/loading/loading.component';
import ConfigUtils from '@/common/utils/config.util';
import BaseSortingComponent from '../../base-sorting/base-sorting.component';
import ErrorCdMsgConstants from '@/common/constants/error-cd-msg.constants';
import SortingUtils from '@/common/utils/sorting.util';

const REF_MODAL = 'sortModal';
const FUNCTIONIDTYPE = 1;
@Component({})
export default class SingleSortingComponent extends BaseSortingComponent {
  // ------------------ 抽象メソッド ------------------
  getErrCdInvalidScanCodeFieldName(): string {
    return ErrorCdMsgConstants.FUNC_SCAN_CONFIRM_INVALID_SCAN_CODE_FIELD_NAME_SINGLE_SORT_ERR_CD;
  }
  getErrCdExcessEntry(): string {
    return '';
  }
  getLogMsgExcessEntry(): string {
    return '';
  }
  getErrMsgOverMaxInput(): string {
    return '';
  }
  getRefModal(): string {
    return REF_MODAL;
  }
  handleCatchError(): void {
    this.scanFailed();
  }
  getWorkInstruction(): number {
    return FUNCTIONIDTYPE;
  }
  getErrMsgInvalidInputQuantity(): string {
    return '';
  }
  // ----------------------抽象メソッドの終わり----------------------

  mounted() {
    (this.$refs.swipeButton as SwipeButton)?.handleError(false);
    window.addEventListener('keydown', this.handleKeyboardEvent);
  }

  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeyboardEvent);
  }

  /**
   * キーボードイベントを処理する。
   *
   * @param {KeyboardEvent} event - キーボードイベント
   */
  handleKeyboardEvent(event: KeyboardEvent): void {
    if (event.key == 'Escape' && this.isShow) {
      this.onClickExitBtn();
    }
  }

  // Call APIs
  // Cancel Task
  private async putCancelTask(): Promise<void> {
    try {
      this.isLoading = true;
      const dataRequest = {
        wesNo: this.wesNo
      } as CancelTaskRequest;
      const res = await this.sortService.putCancelTask(dataRequest);
      if (!res) {
        return;
      }

      this.updateWesNo(0);
      this.updateLastChuteNo('');
      this.updateRejectedTask(false);
      FlashMessage.getInstance().showSuccessMessage('直前投入のキャンセルに成功しました。');
    } catch (e) {
      return;
    } finally {
      this.isLoading = false;
    }
  }

  // Emit events
  private async onClickSubmitBtn() {
    if (this.isLoading && ConfigUtils.isEnableLoadingMode()) {
      return;
    }
    this.hideModal(false, true);
    // CONFIRM MODAL-  SECOND SCAN CONFIRM
    if (this.typeSortModal == SortModalType.CONFIRM) {
      try {
        await this.putScanConfirm(GoFlagOnWarnType.ON);
      } catch (error) {
        this.scanFailed();
      }
    }
    // CANCEL MODAL
    if (this.typeSortModal == SortModalType.CANCEL) {
      await this.putCancelTask();
    }
  }

  private async onClickExitBtn() {
    if (
      !this.scanConfirmField.scanCode &&
      !this.scanConfirmField.linkNumber &&
      !this.scanConfirmField.expirationDate &&
      !this.scanConfirmField.manufacturingLot &&
      !this.scanConfirmField.reserve
    ) {
      this.hideModal(false);
    } else {
      this.hideModal(true);
    }
    if (this.isRFID) {
      this.checkRFID = '';
      this.actualScanTimes = 0;
    }
  }

  render() {
    return (
      <main v-frag>
        {/* Scroll Scan Fields */}
        {this.scrollScanFields}
        {/* Footer Area */}
        <FooterComponent
          footerOfPage={AppConstants.FOOTER_SINGLE_SORTING}
          on-handleCancelTask={() => this.handleModal(SortModalType.CANCEL)}
          wesNo={this.wesNo}
          rejectedTask={this.rejectedTask}
          lastChuteNo={SortingUtils.isSingleSorting ? this.lastChuteNo : ''}
          scanCancelTaskServiceSettingVisibleFlag={
            !this.isRFID && SortingUtils.isSingleSorting && this.scanCancelTaskServiceSettingVisibleFlag
          }
        >
          {!this.isRFID && (
            <template slot="swipeButton">
              <SwipeButton
                on-finished-swipe={() => this.handleModal(SortModalType.CONFIRM)}
                ref="swipeButton"
                text="OK"
              />
            </template>
          )}
        </FooterComponent>
        {/* Modal */}
        <SortingModal
          title={this.titleModal}
          type={this.typeSortModal}
          ref={REF_MODAL}
          isShow={this.isShow}
          fieldNameScanCode={this.fieldNameScanCode}
          scanCodeInput={this.scanConfirmField.scanCode}
          on-exitBtn={this.onClickExitBtn}
          on-acceptBtn={this.onClickSubmitBtn}
        />
        <LoadingComponent isActive={this.isLoading} />
      </main>
    );
  }
}
